import type { SetUserOrganizationsResult } from '@/api/permissions'

type Reconcile = SetUserOrganizationsResult['reconcile']

// Acima deste total de tenants nomeados, cai pros counts (evita toast gigante).
const MAX_NAMES = 6

function fmtTenant(t: { name: string; environment: string }): string {
  return `[${t.environment.toUpperCase()}] ${t.name}`
}

/**
 * Monta a mensagem do toast de reconciliação de tenants (UX-M4).
 *
 * Quando o backend retorna os nomes (`added_tenants`/`removed_tenants`) e o
 * total cabe (≤ MAX_NAMES), exibe os nomes (ex.: "+ [PRD] Acme · − [DEV] Beta").
 * Senão (sem nomes ou lista grande), cai no fallback de contagem.
 */
export function formatReconcileMessage(reconcile: Reconcile): string {
  const { added, removed, added_tenants, removed_tenants } = reconcile
  const totalNamed = (added_tenants?.length ?? 0) + (removed_tenants?.length ?? 0)

  if (totalNamed > 0 && totalNamed <= MAX_NAMES) {
    const parts: string[] = []
    if (added_tenants?.length) parts.push(`+ ${added_tenants.map(fmtTenant).join(', ')}`)
    if (removed_tenants?.length) parts.push(`− ${removed_tenants.map(fmtTenant).join(', ')}`)
    return `Organizações atualizadas. Tenants: ${parts.join(' · ')}.`
  }

  return `Organizações atualizadas. Tenants reconciliados: +${added} / −${removed}.`
}
